import React, { useState, useRef, useEffect, useContext } from 'react';
import '../../scss/Declaration.scss';
import apiRequest from '../ApiRequest';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import NonChangablePackageDetail from '../NonChangablePackageDetail';
import { TrackingIcon, GlobeIcon, InboxIcon } from '../../assets/icons/index';
import Toggle from '../toggle/Toggle';
import ChangablePackageDetails from '../ChangablePackageDetails';
import Button from '../Button';
import SideBar from '../sidebar/SideBar';
import Shippers from '../Shippers';
import AddProduct from './AddProduct';
import AddNew from './AddNew';
import { useTranslation } from 'react-i18next';
import GlobalContext from '../GlobalContext';
import useImage from '../hooks/useImage';
import Modal from '../modal/Modal';
import { getAwaitingAsyncThunk } from '../../store/thunks/packages.thunk';
import { useDispatch } from 'react-redux';
import { getAmountWithCurrency } from '../../utils/utils';
import { getCustomerInfoAsyncThunk } from '../../store/thunks/customer.thunk';
import { useNavigate } from 'react-router';
import { customerSliceActions } from '../../store/slices/customer.slice';

export default function DeclarationWeb({ parcel }) {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { token, setAlert, setToken, setShowLoader } = useContext(GlobalContext);

  useEffect(() => {
    setShowLoader(true);
    const messageHandler = (event) => {
      try {
        const data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;

        if (data.type === 'EXPIRED') {
          localStorage.removeItem('token');
          queryClient.clear();
          setToken(null);
          navigate('/');

          dispatch(customerSliceActions.logout());
        } else if (data.type === 'SUCCESS') {
          setAlert(['success', data.data.message]);
        } else if (data.type === 'ERROR') {
          setAlert(['error', data.data.message]);
        } else if (data.type === 'LOADING') {
          setShowLoader(data.data);
        }
      } catch (error) {}
    };

    window.addEventListener('message', messageHandler);
    return () => window.removeEventListener('message', messageHandler);
  }, []);

  useEffect(() => {
    return () => {
      queryClient.invalidateQueries('getAwaiting');
      dispatch(getAwaitingAsyncThunk());
      queryClient.invalidateQueries('getUsaWarehouse');
      queryClient.invalidateQueries('getPending');
      queryClient.invalidateQueries('getArrived');
      queryClient.invalidateQueries('getReceived');
    };
  }, []);

  const url = 'https://www.usa2georgia.com/declaration/index.php?s_id=' + localStorage.getItem('token') + '&p_id=' + parcel.package_id + '&m=web';

  return (
    <div className='Declaration sideBarChildComponent'>
      <h3 className='SectionTitle sidebarTitle'>{t('_key_declare_package')}</h3>
      <div
        style={{ height: '100%', width: '100%' }}
        dangerouslySetInnerHTML={{
          __html: '<iframe height="100%;" style="width: 100%;" scrolling="no" src="' + url + '" frameborder="no" allowtransparency="true" allowfullscreen="true"></iframe>'
        }}
      />

      {/* <iframe style={{ width: '100%', height: '100%', border: 'none' }} src={url} title='fx.' ref={iframeRef} onLoad={iframeLoaded} /> */}
    </div>
  );
}
